import PropTypes from 'prop-types';

const LINK_PROP_TYPE = PropTypes.shape({
  name: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  additionalActivationPaths: PropTypes.arrayOf(PropTypes.string),
});

export default LINK_PROP_TYPE;
